module.exports = __webpack_public_path__ + "static/media/pid_checklist.01e99c91.svg";